<template>
  <div>
    <source-layer v-model="sourceLayer" :sourceLayers="sourceLayers" :validated="validated"></source-layer>

    <b-row v-if="showNumberError">
      <b-col offset="3" cols="9">
        <small class="text-danger" v-show="numberIsEmpty">
            Należy podać liczbę obiektów.
        </small>
        <small class="text-danger" v-show="numberIsInvalid">
            Podana liczba obiektów jest niepoprawna. Powinna przyjmować wartości od 1 do 255.
        </small>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="3">
        <label for="number">Liczba obiektów</label>
      </b-col>
      <b-col cols="9">
        <b-form-input id="number" v-model.number="number" placeholder="Wpisz" type="number" :state="showNumberError ? false : null"></b-form-input>
      </b-col>
    </b-row>
    
    <reference-layer :readonly="true"></reference-layer>
  </div>
</template>

<script>
import SourceLayer from './SourceLayer';
import ReferenceLayer from './ReferenceLayer';
import { FEATURES_NEAREST_ANALYSIS } from '../../store/actions.type';

export default {
  components: {
    SourceLayer,
    ReferenceLayer
  },
  data() {
    return {
      sourceLayer: null,
      number: null,
      validated: false
    }
  },
  props: {
    sourceLayers: { type: Array, default: () => [] },
    hasErrors: { type: Boolean, default: false },
    waitingForResponse: Boolean
  },
  computed: {
    sourceLayerIdIsEmpty() {
      return !this.sourceLayer;
    },
    numberIsEmpty() {
      return this.number === null || this.number === "";
    },
    numberIsInvalid() {
      return !this.numberIsEmpty && (this.number < 1 || this.number > 255);
    },
    showNumberError() {
      return this.validated && (this.numberIsEmpty || this.numberIsInvalid);
    },
    formHasErrors() {
      return this.sourceLayerIdIsEmpty || this.numberIsEmpty || this.numberIsInvalid;
    }
  },
  watch: {
    formHasErrors(value) {
       this.$emit('update:hasErrors', value);
    }
  },
  methods: {
    async submit() {
      this.validated = true;

      if (!this.formHasErrors) {
        const analysisData = {
          sourceLayerType: this.sourceLayer.type,
          sourceLayerId: this.sourceLayer.id,
          analysisType: 'najblizsze',
          referenceLayerId: this.$store.getters.featuresLayer.id,
          maxQuantity: this.number,
          geometry: this.sourceLayer.geojson
        };

        this.$emit('update:waitingForResponse', true);
        await this.$store.dispatch(FEATURES_NEAREST_ANALYSIS, analysisData);
        this.$emit('update:waitingForResponse', false);
      } else {
        this.$emit('update:hasErrors', true);
      }
    }
  }
}
</script>